import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import StyledIcon from "../StyledIcon";
import FontStyles from "../../constants/FontStyle";

import Colors from "../../constants/Colors";
import HeaderGradient from "./HeaderGradient";
import { useNavigation } from "@react-navigation/native";
import ChatButton from "../common/ChatButton";
import NotificationButton from "../common/NotificationButton";

const HomeHeader: React.FC = function () {
  const navigation = useNavigation();

  const handleSearchClick = () => {
    let query = "*";
    navigation.navigate("ProductExplore", {
      query,
      prev_route: "Home", // initially route.name
    });
  };

  return (
    <>
      <HeaderGradient>
        <View style={styles.container}>
          <View style={styles.topBar}>
            <View
              style={{ flexShrink: 1, alignSelf: "center", paddingRight: 10 }}
            >
              <Text
                style={[
                  FontStyles.white,
                  FontStyles.semibold,
                  FontStyles.size17,
                  FontStyles.lh20,
                ]}
              >
                Buy Products
              </Text>
            </View>

            <View>
              <View
                style={{
                  flexDirection: "row",
                  flexGrow: 1,
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <ChatButton />
                <NotificationButton />
              </View>
            </View>
          </View>
          <TouchableOpacity
            style={styles.searchBox}
            onPress={handleSearchClick}
          >
            <StyledIcon
              iconName="md-search"
              iconColor={Colors.greyColor}
              size={18}
            />
            <Text style={styles.searchBoxText}>Search products</Text>
          </TouchableOpacity>
        </View>
      </HeaderGradient>
    </>
  );
};

export default HomeHeader;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
  },
  topBar: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 18,
  },
  searchBoxContainer: {
    marginBottom: 16,
  },
  searchBox: {
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    marginBottom: 16,
    padding: 10,

    borderRadius: 30,
    height: 38,
    backgroundColor: Colors.whiteColor,
  },
  searchBoxText: {
    ...FontStyles.gray,
    ...FontStyles.size13,
    ...FontStyles.lh16,
    ...FontStyles.medium,
  },
});
